import React from 'react'
import classes from "./HeadCenterTab.module.css";
import {HeaderCenterProps, HeaderTabProps} from "../../../types";
import HeaderTab from "../HeaderTab";

const HeadCenterTab = ({tabData,instanceData}: HeaderCenterProps) => {
    return (
        <>
            <nav className={classes.nav} aria-label="Tabs">
                {tabData.map((tab: HeaderTabProps, index: number) => {
                    return (
                        <HeaderTab
                            label={tab.label}
                            isActive={tab.isActive}
                            isDisabled={tab.isDisabled}
                            isIcon={tab.isIcon}
                            openTab={tab.openTab}
                            key={index}
                            instanceData={instanceData}
                        />
                    )
                })
                }
            </nav>
        </>
    )
}

export default HeadCenterTab;